"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LeidenPopup;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _colors = require("@material-ui/core/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var emails = ['username@gmail.com', 'user02@gmail.com'];
var useStyles = (0, _styles.makeStyles)({
  avatar: {
    backgroundColor: _colors.blue[100],
    color: _colors.blue[600]
  }
});

function LeidenPopup(_ref) {
  var body = _ref.body,
      open = _ref.open,
      handleClose = _ref.handleClose;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    "aria-labelledby": "simple-dialog-title",
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_DialogContentText["default"], {
    id: "alert-dialog-description"
  }, body)));
}